var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M3 5l1-1h12a1 1 0 110 2H4L3 5zm0 5l1-1h12a1 1 0 110 2H4l-1-1zm0 5l1-1h12a1 1 0 110 2H4l-1-1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }